import { of } from 'rxjs';

/*
export const ZAHLUNG = [
  {
    value: 1,
    text: 'jährlich'
  },
  {
    value: 2,
    text: 'halbjährlich'
  },
  {
    value: 3,
    text: 'vierteljährlich'
  },
  {
    value: 4,
    text: 'monatlich'
  }
];
*/

export const FUERWENOPTIONS$ = of([
  {
    Key: '1',
    Id: '1',
    Value: 'Für mich'
  },
  {
    Key: '2',
    Id: '2',
    Value: 'Für mich und meine Kinder'
  },
  {
    Key: '3',
    Id: '3',
    Value: 'Für mich, meine/n Ehepartner/in, Lebensgefährten/in und Kinder'
  },
]);

export const FUERWENOPTIONSEXPERT$ = of([
  {
    Key: '1',
    Id: '1',
    Value: 'Versicherungsnehmer/in'
  },
  {
    Key: '2',
    Id: '2',
    Value: 'Versicherungsnehmer/in und ihre/seine Kinder'
  },
  {
    Key: '3',
    Id: '3',
    Value: 'VN, Ehepartner/in, Lebensgefährt/in und Kinder'
  },
]);
